import { Link } from "@inertiajs/react"

function Container({ children, style }: any) {
  return (
    <div
      className="breadcrumbs text-sm"
      style={style}
    >
      <ul>
        {children}
      </ul>
    </div>
  )
}

function LinkItem({ href, children }: any) {
  return (
    <li>
      <Link
        className="link link-primary"
        href={href}
      >
        {children}
      </Link>
    </li>
  )
}

function TextItem({ children }: any) {
  if (!children) return <></>

  return (
    <li>
      <span>
        {children}
      </span>
    </li>
  )
}

export const BreadCrumbs = {
  Container,
  LinkItem,
  TextItem
}
